import React, { useEffect, useState } from 'react'
import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, SubmitHandler } from 'react-hook-form'
import { errorToast, successToast } from 'src/utils/toastService'
import {
  useAddParkMutation,
  useGetParkByIdQuery,
  useUpdateParkMutation,
} from 'src/api/manageParksApi'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'src/store'
import { startPageLoader, stopPageLoader } from 'src/store/features/common/commonSlice'
import { IFormInput, formSchema } from '../AddParkModal/useAddPark'



type useEditParkProps = {
  successCallback: () => void
  id: number
}
const useEditPark = ({ successCallback, id }: useEditParkProps) => {
  const [file, setFile] = useState<File | null>(null)
  const [imageUrl, setImageUrl] = useState<string>('')
  const [showUploadImage, setShowUploadImage] = useState(false)
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(formSchema),
    mode: 'all',
    defaultValues: {
      name: '',
      address: '',
      about: '',
      latitude: 0,
      longitude: 0,
      open: '',
      close: '',
    },
  })
  const { data, isFetching, refetch } = useGetParkByIdQuery(id)

  const [updatePark, { isLoading: isLoadingEditPark }] = useUpdateParkMutation()
  const dispatch = useDispatch<AppDispatch>()

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length) {
      setFile(e.target.files[0])
    }
  }

  const onSubmit: SubmitHandler<IFormInput> = (data) => {
    console.log(data, file)

    const formData = new FormData()
    formData.append('name', data.name)
    formData.append('address', data.address)
    formData.append('about', data.about)
    formData.append('latitude', data.latitude.toString())
    formData.append('longitude', data.longitude.toString())
    formData.append('opened_at', data.open.toString())
    formData.append('closed_at', data.close.toString())
    if (file) {
      formData.append('picture', file)
    }
    updatePark({
      id,
      data: formData,
    })
      .unwrap()
      .then((res) => {
        console.log(res)
        successToast('Park updated successfully.')
        reset()
        setFile(null)
        successCallback()
      })
      .catch((err) => {
        console.log(err)
        errorToast('Unable to updated park.')
      })
  }
  useEffect(() => {
    if (isFetching) {
      dispatch(startPageLoader())
    } else {
      dispatch(stopPageLoader())
    }
  }, [isFetching])

  useEffect(() => {
    if (data) {
      setValue('name', data.name)
      setValue('address', data.address)
      setValue('about', data.about)
      setValue('latitude', +data.latitude)
      setValue('longitude', +data.longitude)
      setValue('open', data.opened_at)
      setValue('close', data.closed_at)
      if (data.picture) {
        setImageUrl(data.picture)
      }
    }
  }, [data])

  return {
    file,
    handleFileChange,
    onSubmit: handleSubmit(onSubmit),
    control,
    errors,
    isLoadingEditPark,
    imageUrl,
    showUploadImage,
    handleShowUploadImage: () => setShowUploadImage(true),
  }
}

export default useEditPark
